import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const ScoringConfigs = React.lazy(() => import('./index'));
const ScoringConfigTable = React.lazy(() => import('./scoringConfigTable'));
const ScoringConfig = React.lazy(() => import('./scoringConfig'));
const ScoringConfigDetail = React.lazy(() => import('./scoringConfigDetail'));
const AddNewScoringConfig = React.lazy(() => import('./addNewScoringConfig'));
const EditScoringConfig = React.lazy(() => import('./editScoringConfig'));

export const useScoringConfigRoutes = () => {

    return (
        <Route path="scoringConfigs" element={<Suspense fallback={<div>منتظر باشید...</div>}><ScoringConfigs /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ScoringConfigTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewScoringConfig/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><ScoringConfig/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ScoringConfigDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditScoringConfig/></Suspense> } />
            </Route>
        </Route>
    )
}